import { SVG, SVGProps } from './svg'

export function IconShare(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M21 19a3 3 0 1 1-6-.2c0-.2 0-.4-.2-.5l-6.6-3.8a.5.5 0 0 0-.5 0A3 3 0 0 1 6 15a3 3 0 1 1 1.7-5.5h.5l6.6-3.8.2-.4V5a3 3 0 1 1 1 2.3l-6.8 4-.2.5v.5c0 .2 0 .3.2.4l6.6 3.9h.5A3 3 0 0 1 18 16a3 3 0 0 1 3 3Z" />
    </SVG>
  )
}
